import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

type VideoFormatStepProps = {
  selected: string
  onSelect: (size: string) => void
}

const FORMAT_OPTIONS = [
  {
    value: "1280x720",
    labelKey: "landscape720",
    descKey: "landscape720Desc",
    aspectClass: "aspect-video w-20",
  },
  {
    value: "720x1280",
    labelKey: "portrait720",
    descKey: "portrait720Desc",
    aspectClass: "aspect-[9/16] w-10",
  },
] as const

export function VideoFormatStep({ selected, onSelect }: VideoFormatStepProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "studioAi.video.format" })

  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <div>
        <h2 className="text-lg font-semibold">{t("title")}</h2>
        <p className="text-muted-foreground text-sm">{t("description")}</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {FORMAT_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={cn(
              "flex items-center gap-4 rounded-xl border-2 p-5 text-left transition-[border-color,background-color,box-shadow]",
              "hover:border-primary/50 hover:shadow-sm",
              "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none",
              selected === option.value ? "border-primary bg-primary/5 shadow-sm" : "border-border"
            )}
            onClick={() => onSelect(option.value)}
          >
            <div
              className={cn(
                "bg-muted shrink-0 rounded-lg border-2",
                option.aspectClass,
                selected === option.value ? "border-primary" : "border-muted-foreground/30"
              )}
            />
            <div>
              <p className="font-medium">{t(option.labelKey)}</p>
              <p className="text-muted-foreground text-xs">{t(option.descKey)}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
